

$.fn.parallax = function(options) {
  var self = this;

  var options = options || {}

  var elem = $(this);
  
  if (isNaN(options.speed)) {
    var speed = elem.data('parallax-speed');
    options.speed = !isNaN(speed) ? speed : 0.05;  
  }
  
  var rendering = false;
  self.render = function() {
    rendering = false;

    elem.css({
      transform: 'translate3d(0, ' + ($(window).scrollTop() * options.speed) + 'px, 0)'
    });
  };

  $(window).on('scroll', function() {
    if (!rendering) {
      requestAnimationFrame(self.render);
      rendering = true;
    }
  });

  requestAnimationFrame(self.render);

  return self;
};

$(function() {
  $('[data-toggle=parallax]').parallax();
});